<template>
  <div class="cover-bottom media-large">
    <div class="layer media-container">
      <slot name="media"></slot>
    </div>

    <div class="layer content-container">
      <div class="content-box">
        <slot name="header"></slot>
        <slot name="jobCounter"></slot>
        <slot name="ctaButton"></slot>
        <slot name="search"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverBottom",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/media-large";

.content-container {
  justify-content: center;
  align-items: center;

  @include laptop {
    justify-content: flex-end;
  }
}

.content-box {
  text-align: center;

  position: absolute;

  left: 50%;
  width: 100%;
  padding-inline: 25px;

  padding-block: 128px;
  bottom: 10%;
  transform: translateX(-50%);

  @include laptop {
    padding-block: 64px;
  }

  @include tablet {
    padding-block: 32px;
  }

  @include mobile {
    padding-block: 25px;
  }
}
</style>
